module.exports = __webpack_public_path__ + "img/square.a6faba4d.png";